import React from 'react';
import './ScrollingBanner.scss';

const ScrollingBanner = ({ messages = ["Farm Fresh", "Pesticide Free", "Organic", "Cold Pressed", "No Forever Chemicals", "Living Beverages", "Vegan", "Gluten Free", "Kosher"] }) => {
  // Repeat messages to ensure continuous scrolling
  const repeatedMessages = [...messages, ...messages, ...messages];
  
  return (
    <div className="scrolling-banner">
      <div className="scrolling-text">
        {repeatedMessages.map((message, index) => (
          <span key={index} className="banner-message">
            {message}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ScrollingBanner;